module.exports = __webpack_public_path__ + "static/media/pop.a0c7623b.wav";